import script from "./AdminOrderDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminOrderDetails.vue?vue&type=script&setup=true&lang=js"

import "./AdminOrderDetails.vue?vue&type=style&index=0&id=8b7a8972&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b7a8972"]])

export default __exports__